export default () => {
    $('body').on('click', '.c-mini-modal__close-custom', () => {
        if ($(document).find('.c-mini-modal__close').length) {
            $(document).find('.c-mini-modal__close').trigger('click');
        } else {
            window.parent.$('.c-mini-modal__close').trigger('click');
        }
    });
};
